module.exports = __webpack_public_path__ + "static/media/transfer-miles-united.0d2d9798.png";